var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-data-table", {
    directives: [
      {
        name: "resize",
        rawName: "v-resize",
        value: _vm.onResize,
        expression: "onResize"
      }
    ],
    staticClass: "elevation-1 secondarybackground striped-table",
    attrs: {
      dense: "",
      loading: _vm.loading,
      "fixed-header": "",
      "disable-pagination": "",
      "disable-sort": "",
      height: _vm.height,
      "hide-default-footer": "",
      headers: _vm.headers,
      items: _vm.history
    },
    scopedSlots: _vm._u([
      {
        key: "top",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "d-flex justify-end" },
              [
                _c("custom-page-selector", {
                  staticClass: "pa-2",
                  attrs: { namespace: "requests/history" }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "item.intervention_id",
        fn: function({ item }) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(item.intervention_id) +
                "\n    " +
                _vm._s(item.rejected === "O" ? "Rejetée" : "") +
                "\n  "
            )
          ]
        }
      },
      {
        key: "item.request_datetime",
        fn: function({ item }) {
          return [
            item.customer_name
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function({ on }) {
                            return [
                              _c("div", _vm._g({}, on), [
                                _vm._v(
                                  _vm._s(
                                    item.request_datetime.toLocaleDateString()
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.customer_name))])
                  ]
                )
              : _c("div", [
                  _vm._v(_vm._s(item.request_datetime.toLocaleDateString()))
                ])
          ]
        }
      },
      {
        key: "item.on_call",
        fn: function({ item }) {
          return [
            item.on_call === "O"
              ? _c("v-icon", { attrs: { color: "success" } }, [
                  _vm._v("mdi-check")
                ])
              : _vm._e()
          ]
        }
      },
      {
        key: "item.transformed_request",
        fn: function({ item }) {
          return [
            item.transformed_request === "O"
              ? _c("v-icon", { attrs: { color: "success" } }, [
                  _vm._v("\n      mdi-check\n    ")
                ])
              : _vm._e()
          ]
        }
      },
      {
        key: "item.description",
        fn: function({ item }) {
          return [
            _c("truncate-text-with-hover", {
              attrs: { text: item.description, length: 20 }
            })
          ]
        }
      },
      {
        key: "item.technician_comment",
        fn: function({ item }) {
          return [
            _c("truncate-text-with-hover", {
              attrs: { text: _vm.truncateTechnicienComment(item), length: 20 }
            })
          ]
        }
      },
      {
        key: "item.name",
        fn: function({ item }) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  item.technician_firstname + " " + item.technician_lastname
                ) +
                "\n  "
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }